import { RefObject, useEffect } from "react";
import { VideoTypes } from "@bloomberg/media-ui-av";
import { FortressContextValue } from "@foundation/fortress/lib/types";

import { getFortressState } from "~utils/getFortressState";

export default function useVideoFortressPauseTrigger(
    playerRef: RefObject<
        VideoTypes.MediaPlayer | VideoTypes.PlaylistMediaPlayer
    >,
    fortressContext: FortressContextValue
) {
    useEffect(() => {
        if (!playerRef?.current) return;

        if (getFortressState(fortressContext).isBlocked) {
            playerRef.current.pause();
        }
    }, [playerRef, fortressContext]);
}
